import React from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const ChevronRight = ({
  color = colors.primary,
  isInverted = false,
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps & { isInverted?: boolean }) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg width={size} height={size} viewBox="0 0 44 44" fill="none">
          <path
            d="M17.7499 31.9999L27.4998 22.25L17.7499 12.5001"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </View>
    );
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 44 44" fill="none" {...props}>
      <Path
        d="M17.7499 31.9999L27.4998 22.25L17.7499 12.5001"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
